import { useEffect } from 'react';
import { ScreenState } from '../ui/ScreenState.js';
import type { ScreenLifecycleProps } from './screenLifecycle.types.js';

/**
 * Tier-A screen wrapper — P30-G18 dispose hook cancels polling / side effects.
 * Distinct from registry `productLifecycle` (see screen-product-lifecycle.md).
 */
export function ScreenLifecycle({
  screenId,
  phase = 'ready',
  onDisposed,
  children,
  loadingMessage,
  errorMessage,
  emptyMessage,
  onRetry,
}: ScreenLifecycleProps): JSX.Element {
  useEffect(() => {
    return () => {
      onDisposed?.();
    };
  }, [onDisposed]);

  if (phase === 'disposed') {
    return <></>;
  }

  if (phase === 'loading') {
    return (
      <div data-screen-id={screenId} data-screen-phase={phase}>
        <ScreenState variant="loading" message={loadingMessage} />
      </div>
    );
  }

  if (phase === 'error') {
    return (
      <div data-screen-id={screenId} data-screen-phase={phase}>
        <ScreenState variant="error" message={errorMessage} onRetry={onRetry} />
      </div>
    );
  }

  if (phase === 'empty') {
    return (
      <div data-screen-id={screenId} data-screen-phase={phase}>
        <ScreenState variant="empty" message={emptyMessage} />
      </div>
    );
  }

  return (
    <div data-screen-id={screenId} data-screen-phase={phase}>
      {children}
    </div>
  );
}
